import React from 'react'

import Base from '../_Base'

const MpaG = (props) => (
  <Base width="36" height="24" viewBox="0 0 36 24" fill="none" {...props}>
    <rect x=".5" y=".5" width="35" height="23" rx="1.5" stroke="#8C8C8C" />
    <path
      d="M19.056 11.712h4.662v5.535a6.881 6.881 0 0 1-2.151 1.071 8.39 8.39 0 0 1-2.376.333c-1.08 0-2.064-.168-2.952-.504a6.898 6.898 0 0 1-2.268-1.404 6.218 6.218 0 0 1-1.458-2.124A6.889 6.889 0 0 1 12 11.946c0-.978.162-1.875.486-2.691a6.093 6.093 0 0 1 1.386-2.124 6.365 6.365 0 0 1 2.187-1.386c.858-.33 1.815-.495 2.871-.495.546 0 1.059.045 1.539.135.48.09.921.213 1.323.369a6.057 6.057 0 0 1 2.016 1.26l-.882 1.341a.848.848 0 0 1-.54.387c-.216.048-.45-.006-.702-.162A7.867 7.867 0 0 0 21 8.211a3.753 3.753 0 0 0-.648-.261 4.276 4.276 0 0 0-.702-.144 6.888 6.888 0 0 0-.828-.045 3.73 3.73 0 0 0-1.539.306c-.456.198-.846.48-1.17.846a3.881 3.881 0 0 0-.738 1.323 5.274 5.274 0 0 0-.261 1.71c0 .696.096 1.314.288 1.854.192.54.462.996.81 1.368.354.372.774.657 1.26.855a4.445 4.445 0 0 0 1.629.288c.366 0 .696-.036.99-.108.3-.072.591-.168.873-.288v-1.989h-1.296c-.192 0-.342-.051-.45-.153a.51.51 0 0 1-.162-.387v-1.674Z"
      fill="#8C8C8C"
    />
  </Base>
)

export default MpaG
